/* Sero — central content & theme
   ============================================================
   ONE FILE for every editable string, link, image-slot id, color
   and structured array on the page. The React components in
   app.jsx and extras.jsx read from `window.SERO_CONTENT` so that:

   1. You (or a developer) can edit copy here without touching
      component code.
   2. A Shopify Liquid port becomes a 1:1 mapping: each key here
      becomes a `section.settings.*` entry in a section's schema,
      or a metafield on the page. The keys are already grouped
      per section.

   Loaded BEFORE extras.jsx and app.jsx in index.html.
*/

window.SERO_CONTENT = {
  brand: {
    name: "Sero",
    accentDot: ".",
  },

  /* Theme tokens — also driven from CSS custom properties in index.html.
     If you want Tweaks/live editing to swap them, the Tweaks panel
     writes overrides here. */
  theme: {
    accent: "oklch(0.48 0.12 150)",
    accentSoft: "oklch(0.92 0.045 150)",
  },

  nav: {
    links: [
      { label: "Waarom Sero", href: "#redenen" },
      { label: "Vergelijken", href: "#vergelijk" },
      { label: "FAQ", href: "#faq" },
      { label: "Bundels", href: "#bundles" },
    ],
    ctaLabel: "Bekijk aanbod",
    ctaHref: "#bundles",
  },

  hero: {
    announce: "BESPAAR 20% — ABONNEER EN ONTVANG EEN GRATIS WELKOMSTPAKKET",
    announceHighlight: "BESPAAR 20%",
    pill: "ZONDER OPSMUK",
    headlinePre: "5 Redenen waarom je tijdens de overgang een ",
    headlineEm: "andere mens",
    headlinePost: " lijkt en wat je hieraan kunt doen",
    lead: "Vervang door je eigen lead. Twee à drie zinnen die de propositie vertellen — wat krijg je wél bij Sero, wat krijg je niet bij de rest. Geen claims die je niet kunt onderbouwen.",
    ctaPrimary: { label: "Bekijk aanbod", href: "#bundles" },
    ctaSecondary: { label: "Lees de 6 redenen ↓", href: "#redenen" },
    trustNumbers: [
      { v: "16K+", l: "Reviews" },
      { v: "760K+", l: "Aankopen" },
      { v: "23M+", l: "Eenheden" },
    ],
    founderMini: {
      eyebrow: "ONTWIKKELD DOOR",
      name: "Naam · Expert",
      slotId: "founder-mini",
    },
    statsCard: {
      pill: "SEROBOOSTER KLANTONDERZOEK",
      title: "GEVERIFIEERDE KLANTEN:",
      note: "",
      stats: [
        { v: 79, l: "IS POSITIEF VERRAST OVER DE EFFECTEN", icon: "bolt", color: "#e4b232" },
        { v: 81, l: "WIL HET GRAAG BLIJVEN GEBRUIKEN", icon: "user", color: "#48a771" },
        { v: 72, l: "GEEFT AAN DAT HET GOED IS VOOR HUN MENTALE BALANS", icon: "smile", color: "#9a84d9" },
        { v: 95, l: "IS TEVREDEN OVER DE SERVICE EN LEVERING", icon: "target", color: "#da4b82" },
      ],
    },
    trustStrip: [
      "Certificering 1",
      "90+ voordelen",
      "30 dagen garantie",
      "Klinisch getest",
      "Gemaakt in EU",
    ],
  },

  reasons: [
    {
      n: "01", eyebrow: "REDEN ÉÉN",
      title: "Het vermindert (mentale) vermoeidheid overdag",
      body: "Een mentaal dipje gaat vaak hand in hand met een leeg, futloos gevoel. Dankzij ingrediënten als Zink en actief B12 helpt het om vermoeidheid te verminderen overdag. Beide (goed opneembare) stoffen helpen namelijk om jouw interne batterij te activeren.",
      chips: ["Serobooster helpt om serotonine aan te maken", "Claim twee", "Claim drie"],
    },
    {
      n: "02", eyebrow: "REDEN TWEE",
      title: "Het bevat de lichaamseigen bouwsteen van serotonine",
      body: "Serotonine staat bekend als het ‘gelukshormoon’. Serobooster bevat 5-hydroxytryptofaan (natuurlijke stof) uit de griffonia-plant: de directe bouwsteen die je lichaam zelf gebruikt om het gelukshormoon serotonine aan te maken. Zo ondersteun je stemming & humeur van binnenuit.",
      chips: ["Serobooster ondersteunt de aanmaak van natuurlijk slaaphormoon", "Na"],
    },
    {
      n: "03", eyebrow: "REDEN DRIE",
      title: "Het helpt ontspannen in stressvolle perioden",
      body: "Langdurige stress verlaagt de aanmaak van serotonine, wat kan zorgen voor prikkelbaarheid. Serobooster helpt je lichaam om serotonine aan te maken, wat helpt om mentaal in balans te komen én te blijven.",
      chips: ["Serobooster ondersteunt de serotonineaanmaak in de darmen", "Bewijs"],
    },
    {
      n: "04", eyebrow: "REDEN VIER",
      title: "Het ondersteunt de natuurlijke nachtrust van binnenuit",
      body: "Lekker in je vel zitten begint bij goed slapen. Je lichaam heeft serotonine nodig als bouwsteen, om melatonine (natuurlijk slaaphormoon) aan te maken. Door tekort aan serotonine slaap je minder goed. Serobooster helpt je om voldoende serotonine beschikbaar te hebben voor de lichaamseigen aanmaak van melatonine. Zo helpt het je om je nachtrust op natuurlijke wijze te ondersteunen.",
      chips: ["Serobooster bevat deze cruciale hulpstoffen in actieve vorm", "Expert"],
    },
    {
      n: "05", eyebrow: "REDEN VIJF",
      title: "Het is niet verslavend en je kunt stoppen wanneer je wil",
      body: "Serobooster verhoogt niet kunstmatig het serotonine in het brein, maar geeft je lichaam de bouwstenen en hulpstoffen om zelf serotonine aan te maken. Het is om deze reden ook niet verslavend en je kunt stoppen wanneer je wilt. Raadpleeg wel altijd even de huisarts als je momenteel al medicijnen gebruikt.",
      chips: ["Serobooster ondersteunt een normale hormoonhuishouding", "Temperatuur"],
    },
    {
      n: "06", eyebrow: "REDEN ZES",
      title: "Het bevat alleen goedgekeurde, natuurlijke ingrediënten",
      body: "Wat je lichaam binnenkrijgt, doet ertoe. Serobooster bevat uitsluitend natuurlijke, goedgekeurde ingrediënten zoals griffonia-extract, B-vitaminen in actieve vorm en goed opneembaar zink. Alles wordt netjes getest, het wordt in Nederland geproduceerd en je hebt het binnen 24 uur in huis (op werkdagen).",
      chips: ["Serobooster draagt bij aan een normale psychologische functie", "Stress"],
    },
    {
      n: "07", eyebrow: "REDEN ZEVEN",
      title: "Je hebt niet de juiste bouwstenen om serotonine aan te maken",
      body: "Je hoeft de overgang niet gewoon te \"ondergaan\". Serobooster is speciaal samengesteld met 5-HTP, actief B6, actief B12 en zink. En laten dit nou precies de bouwstenen zijn die jouw lichaam nodig heeft om serotonine zelf weer aan te maken. Natuurlijk, zonder verslavende werking, en zonder bijwerkingen!",
      chips: ["Serobooster is hét natuurlijke hulpmiddel voor jouw stemming", "Bouwstenen"],
    },
  ],

  reasonVariants: [
    { kind: "image", badge: "review" },
    { kind: "image", badge: "expert", stats: "rows-a" },
    { kind: "image", badge: "review" },
    { kind: "image", badge: "expert", stats: "rows-b" },
    { kind: "image", badge: "review" },
    { kind: "image", badge: "expert" },
    { kind: "image", badge: "review" },
  ],

  reasonStatsData: {
    "rows-a": {
      eyebrow: "OVERZICHT · PLACEHOLDER",
      title: "Belangrijkste cijfers in één oogopslag.",
      rows: [
        { label: "Kenmerk één",   sub: "Sub · placeholder", value: "+733%" },
        { label: "Kenmerk twee",  sub: "Sub · placeholder", value: "+300%" },
        { label: "Kenmerk drie",  sub: "Sub · placeholder", value: "+150%" },
        { label: "Kenmerk vier",  sub: "Sub · placeholder", value: "+67%" },
        { label: "Kenmerk vijf",  sub: "Sub · placeholder", value: "+54%" },
        { label: "Kenmerk zes",   sub: "Sub · placeholder", value: "+36%" },
      ],
      footnote: "6 KENMERKEN · PLACEHOLDER DREMPEL",
    },
    "rows-b": {
      eyebrow: "VERGELIJK · PLACEHOLDER",
      title: "Sero versus alternatieven.",
      rows: [
        { label: "Punt één",   sub: "Sero vs. rest", value: "+200%" },
        { label: "Punt twee",  sub: "Sero vs. rest", value: "+150%" },
        { label: "Punt drie",  sub: "Sero vs. rest", value: "+90%" },
        { label: "Punt vier",  sub: "Sero vs. rest", value: "+60%" },
        { label: "Punt vijf",  sub: "Sero vs. rest", value: "+45%" },
        { label: "Punt zes",   sub: "Sero vs. rest", value: "+30%" },
      ],
      footnote: "PLACEHOLDER ONDERBOUWING",
    },
  },

  counterStrip: {
    eyebrow: "KLINISCH BEWEZEN · PLACEHOLDER",
    note: "*Op basis van een placeholder studie van 12 weken.",
    stats: [
      { v: 63, suf: "%", label: "Gebruikt dit supplement als vast onderdeel van de avondroutine" },
      { v: 72, suf: "%", label: "Geeft aan dat het goed is voor hun mentale balans" },
      { v: 76, suf: "%", label: "Geeft aan rustiger in slaap te vallen en minder wakker te liggen" },
      { v: 81, suf: "%", label: "Geeft aan Serobooster te willen blijven gebruiken" },
    ],
  },

  reviewsSmall: {
    eyebrow: "WAT KLANTEN ZEGGEN",
    strip: { label: "UITSTEKEND", suffix: "4.8 / 5 · 1.247 BEOORDELINGEN" },
  },

  founderQuote: {
    eyebrow: "WAT WETENSCHAPPERS ZEGGEN",
    quote: "Plaats hier een quote van een expert die jouw verhaal onderbouwt. Houd het concreet en menselijk — wat is anders aan Sero en waarom werkt het? Twee à drie zinnen zijn meestal genoeg om vertrouwen te bouwen.",
    name: "DR. NAAM EXPERT",
    role: "Rol · Organisatie",
    slotId: "founder-portrait",
  },

  comparison: {
    eyebrow: "KLINISCHE VERGELIJKING",
    headlinePre: "De nieuwe",
    headlineEm: "gouden standaard.",
    body: "Zie hoe Sero zich verhoudt op klinische dosering, transparantie van ingrediënten en algehele formulering. Vervang door je eigen data.",
    cols: { sero: "SERO ESSENTIALS", alt: "ALTERNATIEF POEDER" },
    initialCount: 4,
    footnote: "Klinisch gedoseerd in elke portie — kerndoseringen onderbouwd door klinisch onderzoek.",
    rows: [
      {
        name: "Griffonia-extract", plus: "+50%", dose: "300 mg", alt: "200 mg",
        desc: "Plantenextract met natuurlijk 5-hydroxytryptofaan (5-HTP). Dit is de lichaamseigen bouwsteen voor de aanmaak van gelukshormoon serotonine.",
        benefits: ["Bouwsteen van serotonine", "Goed voor stemming & humeur"],
      },
      {
        name: "Actief Vitamine B12", plus: "+150%", dose: "250% RI", alt: "100% RI",
        desc: "De actieve vorm is onmisbaar voor de aanmaak van serotonine en andere neurotransmitters. Helpt het lichaam om 5-HTP om te zetten naar Serotonine.",
        benefits: ["Helpt 5-HTP omzetten naar serotonine", "Ondersteunt stemming en energie"],
      },
      {
        name: "Actief Vitamine B6", plus: "+100%", dose: "100% RI", alt: "50% RI",
        desc: "De ‘mood vitamin’ die je brein helpt serotonine aan te maken en is daarnaast essentieel voor innerlijke balans. We gebruiken de actieve vorm die zich niet ophoopt in je lichaam.",
        benefits: ["Draagt bij aan geestelijke balans", "Speelt een rol bij stemming & energie"],
      },
      {
        name: "Zinkcitraat", plus: "+150%", dose: "25% RI", alt: "10% RI",
        desc: "De stille kracht achter je stemming. Zink werkt als co-factor bij serotonineproductie en helpt je hormonen in balans houden.",
        benefits: ["Ondersteunt de serotonine-aanmaak", "Goed voor je hormoonhuishouding"],
      },
    ],
  },

  bundles: [
    {
      id: "start", name: "1 Zakje", sub: "1 maand",
      pieces: "1 maand", price: "24,95", comparePrice: "28,90", savings: "3,95", per: "/maand",
      perks: ["Goed voor stemming, humeur en mentale balans", "Geen verslavende werking", "Gratis levering binnen 1 werkdag"],
    },
    {
      id: "month", name: "3 Zakjes", sub: "3 maanden",
      pieces: "Doorlopend", price: "59", comparePrice: "103,75", savings: "44,75", per: "/maand", featured: true,
      perks: ["Bonus: Gratis 6 maanden Vitamine D3 (t.w.v. €24,95)", "Gratis levering binnen 1 werkdag"],
    },
    {
      id: "year", name: "6 Zakjes", sub: "6 maanden",
      pieces: "12 maanden", price: "118", comparePrice: "203,55", savings: "85,55", per: "/maand",
      perks: ["Bonus: Gratis 1 jaar Vitamine D3 (t.w.v. €49,90)", "Gratis levering binnen 1 werkdag"],
    },
  ],
  bundlesSection: {
    eyebrow: "KIES JOUW BUNDEL",
    headlinePre: "Drie manieren om",
    headlineEm: "te starten.",
    body: "Korte intro: leg in één zin uit hoe de bundels van elkaar verschillen.",
    footer: "30 DAGEN NIET-GOED-GELD-TERUG · GRATIS VERZENDING",
  },

  ugc: {
    eyebrow: "#SERO · ECHTE MENSEN",
    headlinePre: "Wat onze community",
    headlinePost: "elke dag opnieuw.",
    tiles: [
      { handle: "@gebruiker_een",   tag: "Review", dur: "0:24", src: { kind: "vimeo", val: "1196589520" } },
      { handle: "@gebruiker_twee",  tag: "Review", dur: "0:38", src: { kind: "vimeo", val: "1191512310" } },
      { handle: "@gebruiker_drie",  tag: "Review", dur: "0:47", src: { kind: "vimeo", val: "1196591742" } },
      { handle: "@gebruiker_vier",  tag: "Review", dur: "1:02", src: { kind: "vimeo", val: "1193197625" } },
      { handle: "@gebruiker_vijf",  tag: "Review", dur: "0:31", src: { kind: "vimeo", val: "1193197465" } },
      { handle: "@gebruiker_zes",   tag: "Review", dur: "0:19", src: { kind: "vimeo", val: "1193941180" } },
      { handle: "@gebruiker_zeven", tag: "Review", dur: "0:52", src: { kind: "vimeo", val: "1193197258" } },
      { handle: "@gebruiker_acht",  tag: "Review", dur: "0:28", src: { kind: "vimeo", val: "1193196672" } },
    ],
  },

  reviewsBig: {
    eyebrow: "GEVERIFIEERDE REVIEWS",
    headlineCount: "16.255",
    headlineSuffix: "reviews",
    body: "Echte klanten over hun ervaring met Sero. Vervang door je eigen reviews.",
    strip: { label: "UITSTEKEND", rating: "4.8 / 5" },
    showMore: "Meer reviews tonen →",
    initialCount: 12,
  },

  reviews: [
    { name: "Katelijn Maes",              src: "Geverifieerd", rating: 5, body: "Ik ben 's avonds moe en heb de indruk dat het me helpt met slapen. Het ondersteunt me met mijn stressvolle gevoelens en met mijn stemming!" },
    { name: "Sharon de Jager-Wetzels",    src: "Geverifieerd", rating: 5, body: "Een aantal maanden de Serobooster gebruikt in combinatie met Omega-3. Het hielp me echt met de scherpe kanten van mijn stemming en ondersteunde me met mijn concentratie." },
    { name: "Annelies Versteeg",          src: "Geverifieerd", rating: 5, body: "Ik ben zeer tevreden over dit product. Ik gebruik de capsules nu een jaar, 2x per dag. Het is een aanvulling en ik voel me er hartstikke goed bij." },
    { name: "Monic",                      src: "Geverifieerd", rating: 5, body: "Ik merk vrij snel verschil in mijn gemoedstoestand. Het helpt me met een fit opgewekt gevoel." },
    { name: "Els Beugel",                 src: "Geverifieerd", rating: 5, body: "Ik gebruik dit nu dagelijks en ervaar wat er beloofd wordt. Voorlopig zorg ik voor voldoende voorraad in huis." },
    { name: "Petra Vrijburg",             src: "Geverifieerd", rating: 5, body: "Ik slik dit product nu een dikke week en het helpt echt met slapen! In combinatie met de magnesium & taurine is dit echt een geweldige combinatie!" },
    { name: "Nel Nouwen",                 src: "Geverifieerd", rating: 5, body: "Het werkt voor mij. Gebruik het nu week of 3. Het helpt me bij een rustig en goed gevoel." },
    { name: "Penny van Vugt",             src: "Geverifieerd", rating: 5, body: "Ik heb de Serobooster gebruikt tijdens het proces van stoppen met roken. Het ondersteunde me hierin en ik voelde me in balans." },
    { name: "Maya",                       src: "Geverifieerd", rating: 5, body: "Fijn product. Ik gebruik het al een aantal maanden en ik merk dat het me echt enorm helpt in mijn gemoedstoestand." },
    { name: "Cynthia Vd meer",            src: "Geverifieerd", rating: 5, body: "Soms heb ik het idee dat het helpt met mijn gemoedstoestand maar ook zijn er nog steeds dagen met diepe dalen... maar de aanhouder wint! Dus ga nog even door!" },
    { name: "Melanie C. ",                src: "Geverifieerd", rating: 5, body: "Na een aantal weken is het resultaat goed te merken. Het is zeker geen wondermiddel, maar het haalt de scherpe kantjes er behoorlijk af." },
    { name: "Aaltje M.",                  src: "Geverifieerd", rating: 5, body: "Ik doe het er goed op, na mijn klachten en overprikkeld brein." },
  ],

  // Korte testimonials die naast elk "redenen"-blok staan.
  // Onafhankelijk van `reviews` (het grote reviewblok onderaan), zodat je
  // hier andere klanten kunt tonen zonder de bottom-reviews te wijzigen.
  // Volgorde = volgorde van de redenen (index 0 hoort bij reden 1, enz.).
  reasonReviews: [
    { name: "Anthony D.",                 src: "Geverifieerd", rating: 5, body: "Ik gebruik het inmiddels een maand en merk nu al dat het helpt om mijn vermoeidheid te verminderen. Minder moe omdat ik 's morgens uitgerust wakker word." },
    { name: "ME",                         src: "Geverifieerd", rating: 5, body: "Sinds ik dit supplement elke dag slik, ben ik zeer geholpen met mijn stemming. Het helpt me met een vrolijk en opgewekt gevoel. En dat is een geschenk nu ik mij in de overgangsleeftijd begeef." },
    { name: "Henri Eenkhoorn",            src: "Geverifieerd", rating: 5, body: "Werkt goed om mij te ondersteunen met de scherpe randjes en stressmomenten." },
    { name: "Johanna van B.",             src: "Geverifieerd", rating: 5, body: "Het helpt me wel echt met slapen. Dat is heel opmerkelijk! Dus dat is al een hele belangrijke." },
    { name: "Mimi",                       src: "Geverifieerd", rating: 5, body: "Ik gebruik het alleen wanneer nodig, 's avonds voor het slapen. Sindsdien helpt het me met slapen en ik ben ook geholpen met mijn gevoelens tijdens mijn menstruatie." },
    { name: "Mark Bueters",               src: "Geverifieerd", rating: 5, body: "De serobooster werd netjes aangeleverd in een kartonnen doosje die door de brievenbus kan. Het is een top product wat goed is voor mijn energielevels." },
  ],

  savingsCTA: {
    headline: ["Eén sachet.", "16 supplementen.", "Bespaar"],
    headlineEm: "€2.300+/jr.",
    cta: { label: "Bekijk aanbod →", href: "#bundles" },
    productSlot: "savings-product",
    sticker: {
      eyebrow: "JAARLIJKSE BESPARING",
      amount: "€2.388 – €2.856",
      note: "per jaar bij overstap naar Sero",
    },
    breakdownEyebrow: "MAANDELIJKSE BREAKDOWN",
    breakdownRows: [
      { label: "Natuurlijke samenstelling" },
      { label: "Geen gewenning" },
      { label: "Geen nare bijwerkingen" },
      { label: "Ontworpen voor resultaat" },
      { label: "Snel en eenvoudig in gebruik" },
      { label: "Topkwaliteit plantenextracten" },
      { label: "Vertrouwd door duizenden vrouwen" },
      { label: "Binnen één werkdag geleverd" },
      { label: "100% natuurlijk én veilig" },
    ],
    compareTraditional: { label: "Traditionele supplementen", price: "€267" },
    compareSero: { label: "Sero Essentials", price: "€91" },
  },

  faq: {
    eyebrow: "VEELGESTELDE VRAGEN",
    headlinePre: "Nog vragen?",
    headlineEm: "Hier zijn antwoorden.",
    body: "Vervang de zes placeholder-vragen door echte vragen die je klanten stellen.",
    items: [
      { q: "Wat zit er precies in Serobooster? ", a: "Elke capsule bevat 75 mg natuurlijke 5-HTP uit griffonia-extract, aangevuld met zink, actief vitamine B6 en actieve vormen van vitamine B12. De volledige ingrediëntenlijst staat op het etiket en de productpagina." },
      { q: "Wanneer moet ik Serobooster innemen?", a: "Neem 1 à 2 capsules in de ochtend, bij voorkeur bij een maaltijd. Word je overdag slaperig? Verplaats de inname dan naar de avond voor het slapen gaan. Dit komt doordat 5-HTP ook de aanmaak van melatonine kan ondersteunen, wat bij sommige mensen overdag een rustiger gevoel geeft." },
      { q: "Hoe snel merk ik iets van Serobooster?", a: "De meeste gebruikers merken de eerste effecten na 1 tot 2 weken. Optimale werking treedt doorgaans op tussen 2 en 6 weken, waarbij 4 weken het meest genoemde moment is. Geef het de tijd, de ingrediënten ondersteunen processen die niet van de ene op de andere dag veranderen." },
      { q: "Kan ik Serobooster combineren met antidepressiva of Sint-Janskruid?", a: "Nee, niet zonder overleg met je arts of specialist. Zowel antidepressiva als Sint-Janskruid beïnvloeden de serotoninebalans. De combinatie met 5-HTP kan de serotonineconcentratie te sterk verhogen. Dit geldt ook als je bezig bent met afbouwen. Raadpleeg eerst je behandelaar." },
      { q: "Kan ik Serobooster combineren met andere supplementen, zoals Ashwagandha of Magnesium?", a: "In de meeste gevallen is dat geen probleem. Magnesium & Taurine wordt zelfs regelmatig als aanvullend product gebruikt. Start bij twijfel altijd met één supplement tegelijk, zodat je weet wat je lichaam doet. Bij specifieke medicatie of aandoeningen: overleg eerst met je arts." },
      { q: "Voor wie is Serobooster niet geschikt?", a: "Serobooster is niet geschikt voor mensen die antidepressiva of Sint-Janskruid gebruiken zonder overleg met een arts. Ook tijdens zwangerschap en borstvoeding wordt extra voorzichtigheid aangeraden. Twijfel je of het bij jouw situatie past? Vraag het ons of bespreek het met een zorgverlener." },
    ],
  },

  stickyCTA: {
    title: "Klaar om Sero te proberen?",
    note: "30 DAGEN NIET-GOED-GELD-TERUG",
    price: "VANAF €24/MND",
    cta: { label: "Bekijk aanbod →", href: "#bundles" },
  },

  footer: {
    tagline: "Korte footer-tekst die in één zin samenvat waar Sero voor staat. Vervang door je eigen tagline.",
    columns: [
      { h: "Product", l: ["Reden 1", "Reden 2", "Reden 3", "Bundels"] },
      { h: "Bedrijf", l: ["Over ons", "Pers", "Contact", "Vacatures"] },
      { h: "Juridisch", l: ["Voorwaarden", "Privacy", "Cookies", "Garantie"] },
    ],
    rights: "© " + new Date().getFullYear() + " SERO · ALL RIGHTS RESERVED",
    locale: "NL · EUR · GEMAAKT MET ZORG",
  },
};
